import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api, tokenStore } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = tokenStore.get();
    if (!t) {
      setReady(true);
      return;
    }
    api
      .get('/auth/me')
      .then(({ data }) => setUser(data))
      .catch(() => tokenStore.clear())
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    tokenStore.set(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    tokenStore.clear();
    setUser(null);
  }, []);

  const isSuper = user?.role === 'super_admin';
  const permissions = user?.permissions || [];
  /** Module access check: super admins can do everything; editors only what a super admin ticked for them. */
  const can = useCallback((perm) => !!user && (user.role === 'super_admin' || (user.permissions || []).includes(perm)), [user]);

  return <AuthContext.Provider value={{ user, ready, login, logout, isSuper, permissions, can, setUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
